module.exports = __webpack_public_path__ + "media/images/pear_6-e00b5d0e38442450c68562e3e2dd1814.jpg";